import { useContext, useMemo } from 'react';

import { historyContext } from 'src/modules/designStudio/providers';
import { context } from 'src/modules/designStudio/providers/DesignStudioServiceProvider';

export type CommonTrackingData = {
  job_id: number | undefined;
  org_id: number | undefined;
  partner_id: number | undefined;
  user_id: number | undefined;
  user_email: string | undefined;
  page_or_screen_name: 'Design-studio';
};

export const useCommonTrackingData = (): CommonTrackingData => {
  const { historyState } = useContext(historyContext);
  const { appService } = useContext(context);

  return useMemo(() => {
    if (!appService || !appService.getSnapshot) {
      return {
        job_id: historyState.jobId ?? undefined,
        org_id: undefined,
        partner_id: undefined,
        user_id: undefined,
        user_email: historyState.email ?? undefined,
        page_or_screen_name: 'Design-studio',
      };
    }
    const appSnapshot = appService.getSnapshot();
    return {
      job_id: historyState.jobId ?? undefined,
      org_id: appSnapshot.context.orgId,
      partner_id: appSnapshot.context.partnerId,
      user_id: appSnapshot.context.userId,
      user_email: historyState.email ?? undefined,
      page_or_screen_name: 'Design-studio',
    };
  }, [historyState, appService]);
};
